<footer class="app-footer">
  <span><a href="https://www.kampunginggris.id/">LC All In One</a> &copy; {{year}} LC Kampung Inggris.</span>
  <!-- <span class="ml-auto">Powered by <a href="http://coreui.io">CoreUI</a></span> -->
</footer>
